import UploadBrowseFile from 'components/BrowseFile/uploadRedux.component';
import Button from 'components/Button/button.component';
import WidgetDialog from 'components/Dialog/dialog.component';
import HistoricoAnalisePrestacao from 'components/HistoricoAnalisePrestacao/historicoAnalisePrestacao';
import Title from 'components/Title/title.component';
import { saveAs } from 'file-saver';
import React, { Component } from 'react';
import downloadService from 'services/downloadService';
import prestacaoContasService from 'services/prestacaoContasService';
import FileHelper from 'utils/fileHelpers';
import { PRESTACAO_CONTAS_MODEL } from 'utils/models';
import ToastHelper from 'utils/toastHelper';
import exportService from '../../services/exportaPDFService';
import AnalisePrestacaoCrepdec from './analisePrestacaoCrepdec/analisePrestacaoCrepdec.page';
import AnalisePrestacaoDaca from './analisePrestacaoDaca/analisePrestacaoDaca.page';
import AnalisePrestacaoSubChefia from './analisePrestacaoSubChefia/analisePrestacaoSubChefia.page';
import PrestacaoContasMunicipio from './prestacaoContasMunicipio/prestacaoContasMunicipio.page';
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import moment from "moment";

class AnalisePrestacaoContainer extends Component {
	columnsDocumentos = [
		{ id: 0, title: 'Nome', property: 'nome' },
		{ id: 1, title: 'Tipo', property: 'tipoDocumento.nome' },
	];

	columnsDocumentosSemTipo = [
		{ id: 0, title: 'Nome', property: 'nome' },
	];

	actionsDocumentos = [
		{
			name: 'Documento',
			icon: 'fas fa-download',
			action: item => this.downloadFile(item),
		},
	];

	constructor(props) {
		super(props);
		this.state = {
			prestacaoConta: PRESTACAO_CONTAS_MODEL,
			isOpenDialogCancelar: false,
			documentoSelecionado: null,
			files: [],
			hasCertidao: false,
			hasAtestado: false,
			documentosDownload: [],
			key: 0,
			isDirty: false,
			isOpenEditar: false,
			showLoading: false,
		};
		this.onChangeDocumento = this.onChangeDocumento.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.handleRichText = this.handleRichText.bind(this);
		this.handleCancelar = this.handleCancelar.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
		this.removeUpload = this.removeUpload.bind(this);
	}

	async componentDidMount() {
		const {
			match: { params },
		} = this.props;

		this.setState({ showLoading: true });
		const { data } = await prestacaoContasService.findPrestacaoContaById(params.id);

		// busca as informações do status da ocorrência
		if ((((data || {}).historicoDaca || {}).ocorrencia || {}).id != null) {
			await prestacaoContasService.findByOcorrenciaInfoStatus(data.historicoDaca.ocorrencia.id)
				.then((response) => {
					data.infoStatus = response.data;
				});
		}

		if (data.documentos == null) {
			data.documentos = [];
		}

		this.setState({
			// seta os documentos para download, das análises anteriores
			documentosDownload: [...data.documentos],

			prestacaoConta: {
				...data,
				observacoes: '',
				isRevisao: null,
				documentos: [],
				infoStatus: data.infoStatus,
				key: this.state.key + 1,
			},
			showLoading: false,
		});
	}

	onChangeDocumento(item, tipoDocumentoSelecionado, tipoDocumento) {
		/* Cria um novo estado, com os campos do select, usado aqui porque os selects
		usam campos, com valoes labels e values e no nosso caso, usamos nome ao inves de label,
		e o id ao inves de value */
		const newState = this.state;
		newState[tipoDocumentoSelecionado] = item.object;
		newState.prestacaoConta[tipoDocumento] = item.object;
		newState.isDirty = true;
		newState.files = [];
		this.setState(newState);
	}

	/*
		HANDLERS PARA CANCELAR
	*/

	handleCancelar = () => {
		this.setState({ isOpenDialogCancelar: true });
	};

	handleDialogCancelar = ({ isOpenDialogCancelar, isDirty }, { history }) => {
		/* caso o algum campo tenha sido 'sujado' */
		if (isDirty) {
			return (
				<WidgetDialog
					title='Atenção!'
					isOpen={isOpenDialogCancelar}
					textCancelar='Não'
					textConfirmar='Sim'
					mensagem='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos'
					cancelar={() => {
						this.setState({ isOpenDialogCancelar: false });
					}}
					confirmar={() => {
						this.setState({ isOpenDialogCancelar: false });
						history.push('/prestacaoContas');
					}}
				/>
			);
		}
		/* Caso não tenha sido sujado e o dialog seja true para abrir */
		if (isOpenDialogCancelar) {
			history.push('/prestacaoContas');
		}
	};

	/*
		HANDLERS DE VOLTAR
	*/
	handleVoltar = () => {
		const { history } = this.props;
		history.push('/prestacaoContas');
	};

	/*
		HANDLERS DE INPUT
	*/

	handleInputChange = (event) => {
		const { prestacaoConta } = this.state;
		const { target } = event;
		const { name } = target;

		this.setState({
			isDirty: true,
			prestacaoConta: {
				...prestacaoConta,
				[name]: target.value,
			},
		});
	}

	// tem o próprio handler, por mandar o valor direto e não o evento
	handleRichText = (value, delta, source, editor) => {
		const { prestacaoConta } = this.state;
		const isVazio = editor.getText().trim();

		if (isVazio === '') {
			this.setState({
				isDirty: true,
				prestacaoConta: {
					...prestacaoConta,
					observacoes: '',
				},
			});
		} else {
			this.setState({
				isDirty: true,
				prestacaoConta: {
					...prestacaoConta,
					observacoes: value,
				},
			});
		}
	}

	/*
		HANDLERS DE SUBMIT
	*/
	handleSubmit = async () => {
		const {
			state: { prestacaoConta, hasAtestado, hasCertidao },
			props: { match: { params }, history },
		} = this;

		/* Apenas é necessário quando o local for municipio, que o documento é obrigatório */
		if ((hasAtestado && hasCertidao) || params.localProcesso !== 'municipio') {
			await prestacaoContasService
				.finalizarPrestacaoConta(prestacaoConta)
				.then(() => {
					ToastHelper.success(
						'Prestação de contas finalizada com sucesso!',
					);
					history.push('/prestacaoContas');
				});
		} else {
			ToastHelper.warn(
				'Confira se anexou os documentos obrigatórios.',
			);
		}
	};

	/*
		DOWNLOAD E UPLOAD
	*/
	onDrop = async (files, values) => {
		const { state: { prestacaoConta }, props: { match: { params } } } = this;
		const response = await prestacaoContasService.uploadDocumento(values, files);

		/*
			Registra a resposta do upload, a resposta é o registro inteiro, mais o documento.
			Serve para não perder os dados, ao fazer o upload
		*/
		response.documento.tipoDocumento = prestacaoConta.tipoDocumento;

		/* Apenas para a primeira etapa do processo, de prestcao de contas do municipio */
		if (params.localProcesso === 'municipio') {
			if (prestacaoConta.tipoDocumento.id === 2) {
				this.setState({
					hasAtestado: true,
				});
			}

			if (prestacaoConta.tipoDocumento.id === 3) {
				this.setState({
					hasCertidao: true,
				});
			}
		}

		this.setState({
			isDirty: true,
			prestacaoConta: {
				...prestacaoConta,
				documentos: [...prestacaoConta.documentos, response.documento],
			},
			files: [],
		});
	}

	downloadFile = async (registro) => {
		const { data: arquivo } = await downloadService.download(registro);
		const fileSignature = FileHelper.buf2hex(arquivo);
		const fileMimeType = FileHelper.getMimetype(fileSignature.slice(0, 8));

		const blob = new Blob([arquivo], { type: fileMimeType });
		saveAs(blob, registro.nome);
	};

	removeUpload = (item) => {
		const { prestacaoConta } = this.state;

		/*
			Filtra documentos
			Percorre o array de documentos procurando o 'item' que será excluído,
			todos documentos que forem diferentes do item procurado
			vão para o novo array 'filtro', que é atualizado no estado
		*/
		const filtro = prestacaoConta.documentos.filter(documento => documento !== item);

		this.setState({
			prestacaoConta: {
				...prestacaoConta,
				documentos: filtro,
			},
		}, item.tipoDocumento ? this.setSuccess : null); // apenas para municipio
	}

	/* Função para atualizar o success de documento carregado dos modelos */
	setSuccess = () => {
		const { prestacaoConta } = this.state;

		/*
			Essa função procura se há documentos do tipo atestado, depois da função removeUpload
			ser chamada, caso não haja, remove o success do documento.
			Usado para saber se há algum documento restante do tipo atestado
		*/

		const hasFindedAtestado = prestacaoConta.documentos.find(
			documento => documento.tipoDocumento.id === 2,
		);

		if (!hasFindedAtestado) {
			this.setState({
				hasAtestado: false,
			});
		}

		/*
			A mesma coisa da função acima, só que para o tipo de documento certidao
		*/
		const hasFindedCertidao = prestacaoConta.documentos.find(
			documento => documento.tipoDocumento.id === 3,
		);

		if (!hasFindedCertidao) {
			this.setState({
				hasCertidao: false,
			});
		}
	}

	render() {
		const {
			state: {
				prestacaoConta,
				hasAtestado,
				hasCertidao,
				documentosDownload,
			},
			props: {
				match: { params },
			},
		} = this;
		return (
			<div>
				{this.state.showLoading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}
				<HeaderInfos prestacaoConta={prestacaoConta} params={params} />
				<HistoricoAnalisePrestacao
					saidaDaca={documentosDownload}
					historicos={prestacaoConta}
					columnsDocumentos={this.columnsDocumentos}
					actionsDocumentos={this.actionsDocumentos}
					columnsDocumentosSemTipo={this.columnsDocumentosSemTipo}
				/>

				{params.localProcesso === 'municipio'
					&& (
						<PrestacaoContasMunicipio
							upload={(
								<UploadBrowseFile
									context={this}
									acceptedFileTypes={
										[
											'application/pdf',
											'application/msword',
											'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
											'image/png',
											'image/jpeg',
											'image/jpg',
											'application/doc',
											'.docx',
											'application/txt',
										]
									}
									label='<span class="pointer-text"> Arraste e solte ou <b>clique</b> para selecionar um arquivo.</span>'
									onUpload={this.onDrop}
									aspectRatio={0.1}
									expetedTypesLabel='Selecione arquivos de imagens'
									handleRemoveFile={() => {
										this.setState({
											files: [],
										});
									}}
								/>
							)}
							onChangeDocumento={this.onChangeDocumento}
							handleSubmit={this.handleSubmit}
							handleRichText={this.handleRichText}
							handleCancelar={this.handleCancelar}
							downloadFile={this.downloadFile}
							removeUpload={this.removeUpload}
							state={this.state}
							hasAtestado={hasAtestado}
							hasCertidao={hasCertidao}
						/>
					)
				}

				{params.localProcesso === 'crepdec'
					&& (
						<AnalisePrestacaoCrepdec
							upload={(
								<UploadBrowseFile
									context={this}
									acceptedFileTypes={
										[
											'application/pdf',
											'application/msword',
											'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
											'image/png',
											'image/jpeg',
											'image/jpg',
											'application/doc',
											'.docx',
											'application/txt',
										]
									}
									label='<span class="pointer-text"> Arraste e solte ou <b>clique</b> para selecionar um arquivo.</span>'
									onUpload={this.onDrop}
									aspectRatio={0.1}
									expetedTypesLabel='Selecione arquivos de imagens'
									handleRemoveFile={() => {
										this.setState({
											files: [],
										});
									}}
								/>
							)}
							handleInputChange={this.handleInputChange}
							handleSubmit={this.handleSubmit}
							handleRichText={this.handleRichText}
							handleCancelar={this.handleCancelar}
							downloadFile={this.downloadFile}
							removeUpload={this.removeUpload}
							state={this.state}
						/>
					)
				}

				{params.localProcesso === 'daca'
					&& (
						<AnalisePrestacaoDaca
							upload={(
								<UploadBrowseFile
									context={this}
									acceptedFileTypes={
										[
											'application/pdf',
											'application/msword',
											'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
											'image/png',
											'image/jpeg',
											'image/jpg',
											'application/doc',
											'.docx',
											'application/txt',
										]
									}
									label='<span class="pointer-text"> Arraste e solte ou <b>clique</b> para selecionar um arquivo.</span>'
									onUpload={this.onDrop}
									aspectRatio={0.1}
									expetedTypesLabel='Selecione arquivos de imagens'
									handleRemoveFile={() => {
										this.setState({
											files: [],
										});
									}}
								/>
							)}
							handleInputChange={this.handleInputChange}
							handleSubmit={this.handleSubmit}
							handleRichText={this.handleRichText}
							handleCancelar={this.handleCancelar}
							downloadFile={this.downloadFile}
							removeUpload={this.removeUpload}
							state={this.state}
						/>
					)
				}

				{params.localProcesso === 'subchefia'
					&& (
						<AnalisePrestacaoSubChefia
							upload={(
								<UploadBrowseFile
									context={this}
									acceptedFileTypes={
										[
											'application/pdf',
											'application/msword',
											'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
											'image/png',
											'image/jpeg',
											'image/jpg',
											'application/doc',
											'.docx',
											'application/txt',
										]
									}
									label='<span class="pointer-text"> Arraste e solte ou <b>clique</b> para selecionar um arquivo.</span>'
									onUpload={this.onDrop}
									aspectRatio={0.1}
									expetedTypesLabel='Selecione arquivos de imagens'
									handleRemoveFile={() => {
										this.setState({
											files: [],
										});
									}}
								/>
							)}
							handleInputChange={this.handleInputChange}
							handleSubmit={this.handleSubmit}
							handleRichText={this.handleRichText}
							handleCancelar={this.handleCancelar}
							downloadFile={this.downloadFile}
							removeUpload={this.removeUpload}
							state={this.state}
						/>
					)
				}

				{params.localProcesso === 'visualizar'
					&& (
						<div className='row mt-3 mb-3'>
							<div className='col-12'>
								<div className='float-left'>
									<Button
										onClick={() => this.handleVoltar()
										}
										primary
										type='button'
										text='Voltar'
										icon='fas fa-arrow-left'
									/>
								</div>
							</div>
						</div>
					)
				}

				{this.handleDialogCancelar(this.state, this.props)}

			</div>
		);
	}
}

export default AnalisePrestacaoContainer;

/* FUNCTIONS */

/*
	Formata data no padrão dd-mm-yyyy hh:mm
*/
const formataDataParaExportacao = () => {
	let formataData = new Date();

	const dia = String(formataData.getDate()).padStart(2, '0');
	const mes = String(formataData.getMonth() + 1).padStart(2, '0');
	const ano = formataData.getFullYear();

	const hora = String(formataData.getHours()).padStart(2, '0');
	const minuto = String(formataData.getMinutes()).padStart(2, '0');
	formataData = `${dia}-${mes}-${ano}_${hora}-${minuto}`;

	return formataData;
};

const getDataOcorrencia = (historicoDaca) => {
	if (historicoDaca) {

		let formataData = moment(historicoDaca.ocorrencia.data, 'DD/MM/YYYY HH:mm');
		let formataHora = moment(historicoDaca.ocorrencia.hora, 'DD/MM/YYYY HH:mm');

		const dia = String(formataData.date()).padStart(2, '0');
		const mes = String(formataData.month() + 1).padStart(2, '0');
		const ano = formataData.year();
		const hora = String(formataHora.hour()).padStart(2, '0');
		const minuto = String(formataHora.minute()).padStart(2, '0');
		const dataCompleta = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

		return !isNaN(formataData.valueOf()) && !isNaN(formataHora.valueOf()) ? dataCompleta : '--';
	}
	return '--';
};

const handleExportar = async (id) => {
	const { data: arquivo } = await exportService.exportPrestacaoContasPDF(id);
	const blob = new Blob([arquivo], { type: 'application/pdf' });
	const dataAtualFormatada = formataDataParaExportacao();
	const fileName = `Prestacao_de_contas-${dataAtualFormatada}`;
	saveAs(blob, fileName);
};

const HeaderInfos = ({ prestacaoConta, params }) => (
	<div className='card'>
		<div className='card-body'>
			<div className='row'>
				<div className='card-title col-6'>
					<Title>Informações do processo</Title>
				</div>
				<div className='col-6'>
					{params.localProcesso === 'visualizar'
						&& (
							<Button
								onClick={() => handleExportar(prestacaoConta.id)}
								className='float-right'
								primary
								type='button'
								text='Exportar PDF'
								icon='fas fa-file-pdf'
							/>
						)}
				</div>
			</div>
			<hr />
			<div className='row'>
				<label className='col-4'>
					<b>Nº do processo:</b>
					{' '}
					{prestacaoConta.numeroProcesso || '--'}
				</label>
				<label className='col-4'>
					<b>Ocorrência:</b>
					{' '}
					{prestacaoConta.historicoDaca ? prestacaoConta.historicoDaca.ocorrencia.eventoAdverso.nome : '--'}
				</label>
				<label className='col-4'>
					<b>Status:</b>
					{' '}
					{prestacaoConta.status.nome || '--'}
				</label>
			</div>

			<div className='row'>
				<label className='col-4'>
					<b>Município:</b>
					{' '}
					{prestacaoConta.historicoDaca ? prestacaoConta.historicoDaca.ocorrencia
						.municipio.nome : '--'}
				</label>
				<label className='col-4'>
					<b>Data/Hora da ocorrência:</b>
					{' '}
					{getDataOcorrencia(prestacaoConta.historicoDaca)}
				</label>
			</div>
		</div>
	</div>
);
